// src/components/Testimonials.jsx
import React, { useState, useEffect } from 'react';

const testimonials = [
  {
    text: "VIHA MindCare changed my life. I struggled with anxiety for years, and after just a few sessions, I finally felt in control. The team is warm, professional, and truly caring.",
    name: 'Priya S.',
    initials: 'PS',
    rating: 5,
    service: 'Anxiety Counseling',
  },
  {
    text: "My son was struggling in school and with social situations. The counselors here understood him completely. We've seen a remarkable transformation in just two months.",
    name: 'Rajesh M.',
    initials: 'RM',
    rating: 5,
    service: 'Children & Adolescent Counseling',
  },
  {
    text: "As a couple, we were on the verge of separation. The relationship counseling sessions helped us rediscover each other and rebuild our communication. Forever grateful.",
    name: 'Anita & Vikram P.',
    initials: 'AV',
    rating: 5,
    service: 'Couple Counseling',
  },
  {
    text: "I was skeptical about therapy at first, but VIHA MindCare made me feel safe and understood from day one. Highly recommend to anyone facing life challenges.",
    name: 'Sneha K.',
    initials: 'SK',
    rating: 5,
    service: 'Individual Counseling',
  },
  {
    text: "The stress management sessions were exactly what I needed during a difficult career transition. Practical tools, compassionate guidance, and real results.",
    name: 'Aditya R.',
    initials: 'AR',
    rating: 5,
    service: 'Stress Management',
  },
];

const StarRating = ({ count }) => (
  <div style={{ display: 'flex', gap: 3 }}>
    {Array.from({ length: count }).map((_, i) => (
      <span key={i} style={{ color: '#F5A623', fontSize: 18 }}>★</span>
    ))}
  </div>
);

const Testimonials = () => {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setActive((a) => (a + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const t = testimonials[active];

  return (
    <section className="viha-section" style={styles.section}>
      <div style={styles.container}>
        <div style={styles.header} data-aos="fade-up">
          <span className="section-badge">What Clients Say</span>
          <h2 style={styles.title}>Stories of Healing &amp; Transformation</h2>
        </div>

        <div style={styles.carouselWrap}>
          {/* Main card */}
          <div style={styles.card} key={active}>
            <div style={styles.quoteIcon}>"</div>
            <p style={styles.quoteText}>{t.text}</p>
            <StarRating count={t.rating} />
            <div style={styles.clientRow}>
              <div style={styles.avatar}>{t.initials}</div>
              <div>
                <div style={styles.clientName}>{t.name}</div>
                <div style={styles.clientService}>{t.service}</div>
              </div>
            </div>
          </div>

          {/* Dot indicators */}
          <div style={styles.dots}>
            {testimonials.map((_, i) => (
              <button
                key={i}
                style={styles.dot(i === active)}
                onClick={() => setActive(i)}
                aria-label={`Testimonial ${i + 1}`}
              />
            ))}
          </div>

          {/* Prev / Next */}
          <div style={styles.navRow}>
            <button
              style={styles.navBtn}
              onClick={() => setActive((a) => (a - 1 + testimonials.length) % testimonials.length)}
              aria-label="Previous testimonial"
            >
              ‹
            </button>
            <button
              style={styles.navBtn}
              onClick={() => setActive((a) => (a + 1) % testimonials.length)}
              aria-label="Next testimonial"
            >
              ›
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

const styles = {
  section: {
    backgroundColor: '#ffffff',
  },
  container: {
    maxWidth: 860,
    margin: '0 auto',
    padding: '0 24px',
  },
  header: {
    textAlign: 'center',
    marginBottom: 48,
  },
  title: {
    fontFamily: "'Playfair Display', serif",
    fontSize: 'clamp(24px, 3.5vw, 36px)',
    color: '#1B3F6E',
    marginTop: 8,
  },
  carouselWrap: {
    position: 'relative',
  },
  card: {
    backgroundColor: '#ffffff',
    borderRadius: 20,
    padding: '48px 48px 36px',
    boxShadow: '0 8px 40px rgba(27,63,110,0.12)',
    border: '1px solid #D6E8F7',
    position: 'relative',
    animation: 'fadeInUp 0.4s ease',
    minHeight: 280,
  },
  quoteIcon: {
    fontFamily: "'Playfair Display', serif",
    fontSize: 96,
    color: '#5A9E4B',
    opacity: 0.25,
    position: 'absolute',
    top: 8,
    left: 32,
    lineHeight: 1,
    userSelect: 'none',
  },
  quoteText: {
    fontFamily: "'Playfair Display', serif",
    fontStyle: 'italic',
    fontSize: 17,
    color: '#2C2C2C',
    lineHeight: 1.85,
    marginBottom: 20,
    position: 'relative',
    zIndex: 1,
  },
  clientRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 14,
    marginTop: 24,
  },
  avatar: {
    width: 48,
    height: 48,
    borderRadius: '50%',
    backgroundColor: '#1B3F6E',
    color: '#ffffff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: "'Lato', sans-serif",
    fontWeight: 700,
    fontSize: 14,
    flexShrink: 0,
  },
  clientName: {
    fontFamily: "'Lato', sans-serif",
    fontWeight: 700,
    fontSize: 15,
    color: '#1B3F6E',
  },
  clientService: {
    fontFamily: "'Lato', sans-serif",
    fontSize: 12,
    color: '#5A9E4B',
    fontWeight: 600,
    marginTop: 2,
  },
  dots: {
    display: 'flex',
    justifyContent: 'center',
    gap: 8,
    marginTop: 28,
  },
  dot: (active) => ({
    width: active ? 28 : 10,
    height: 10,
    borderRadius: 5,
    backgroundColor: active ? '#1B3F6E' : '#D6E8F7',
    border: 'none',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    padding: 0,
  }),
  navRow: {
    display: 'flex',
    justifyContent: 'center',
    gap: 12,
    marginTop: 20,
  },
  navBtn: {
    width: 44,
    height: 44,
    borderRadius: '50%',
    border: '2px solid #1B3F6E',
    background: 'transparent',
    color: '#1B3F6E',
    fontSize: 22,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'all 0.25s ease',
    fontFamily: 'monospace',
    lineHeight: 1,
  },
};

export default Testimonials;
